import { useTranslation } from 'react-i18next';
import type { StallStatus } from '@/api/types';

interface Props {
  status: StallStatus;
  justOpened?: boolean;
}

export function LivePill({ status, justOpened }: Props) {
  const { t } = useTranslation();
  if (justOpened) {
    return <span className="just-opened">{t('live.just_opened')}</span>;
  }
  if (status === 'open') {
    return (
      <span className="live-pill">
        <span className="dot" aria-hidden="true" />
        <span>{t('live.now')}</span>
      </span>
    );
  }
  if (status === 'closed') {
    return <span className="closed-pill">{t('live.closed')}</span>;
  }
  return (
    <span
      className="closed-pill"
      style={{
        background: 'color-mix(in srgb, var(--steel) 30%, var(--surface))',
        color: 'var(--ink-soft)',
      }}
    >
      {t('live.unknown')}
    </span>
  );
}
